/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { RequestTemplatesService } from '@src/app/modules/crm/request-templates.service';
import { FormDateComponent } from '@src/app/shared/form/form-date/form-date.component';
import { FormPicklistComponent } from '@src/app/shared/form/form-picklist/form-picklist.component';
import { required } from '@src/app/shared/validators';
import { AbstractObject, uuid } from '@src/app/model/abstract-object';
import { Frequency } from '@src/app/model/frequency';
import { RequestTemplate } from '@src/app/model/RequestTemplate';
import { ServiceRequest } from '@src/app/model/serviceRequest';
import { Omc } from '@src/app/model/Omc';
import { Supplier } from '@src/app/model/supplier';

export class RecurringJob extends AbstractObject {
    constructor(o: Partial<RecurringJob> = {}) {
        super(o);
    }

    omcId: uuid;
    omc: Omc;

    agentTeamId: uuid;

    templateId: uuid;
    template: RequestTemplate;

    lastId: uuid;
    lastRequest: ServiceRequest;

    occurences: ServiceRequest[] = [];
    nextOccurence: string;

    occurences_count: string; // server passes as string, bizarre...
    yearOccurences: string; // server passes as string, bizarre...

    frequencyId: uuid;
    frequency: Frequency;

    supplierId: uuid;
    supplier: Supplier;
    supplier_open_count: number;
    
    timesDone = 0;

    static lastDoneMessage(sr: ServiceRequest) {
        if (sr) {
            return sr.refNr + ' - ' + sr.title; // + ' (' + sr.srStatus + ')';
        }
        return '';
    }

    static getTmplField(tmplSvc: RequestTemplatesService) {
        return FormPicklistComponent.make('Standard Request', 'templateId', 'template', { service: tmplSvc }, { validators: [required] });

    }

    static getFrequencyField() {
        return FormPicklistComponent.make('Frequency', 'frequencyId', 'frequency',
            { items: Frequency.ALL_OPTIONS, optionDisplayValue: o => o.name },
            { validators: [required], formColumn: 2 });
    }

    static getNextField() {
        return FormDateComponent.make('Next Needs To Be Planned', 'nextOccurence');
    }

}
